import {
  ERROR_MESSAGES,
  PARENT_CODE_PATTERN,
  STUDENT_CODE_PATTERN,
  type ParentRegistrationData,
  type StudentRegistrationData,
  type UnifiedRegistrationData,
  type ValidationErrors,
} from '../types/registration';

export const validateRegistrationData = (
  data: UnifiedRegistrationData
): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!data.name.trim()) {
    errors.name = ERROR_MESSAGES.required;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!data.email.trim()) {
    errors.email = ERROR_MESSAGES.required;
  } else if (!emailRegex.test(data.email)) {
    errors.email = ERROR_MESSAGES.invalidEmail;
  }

  if (!data.password) {
    errors.password = ERROR_MESSAGES.required;
  } else if (data.password.length < 6) {
    errors.password = ERROR_MESSAGES.passwordTooShort;
  }

  if (!data.confirmPassword) {
    errors.confirmPassword = ERROR_MESSAGES.required;
  } else if (data.password !== data.confirmPassword) {
    errors.confirmPassword = ERROR_MESSAGES.passwordMismatch;
  }

  const phoneRegex = /^\+?[0-9\s\-()]{8,}$/;
  if (!data.phone.trim()) {
    errors.phone = ERROR_MESSAGES.required;
  } else if (!phoneRegex.test(data.phone.replace(/\s/g, ''))) {
    errors.phone = ERROR_MESSAGES.invalidPhone;
  }

  if (data.userType === 'student') {
    const studentData = data as StudentRegistrationData;
    if (!studentData.grade) {
      errors.grade = ERROR_MESSAGES.required;
    }
    if (
      studentData.parentCode?.trim() &&
      !PARENT_CODE_PATTERN.test(studentData.parentCode.trim().toUpperCase())
    ) {
      errors.parentCode = ERROR_MESSAGES.invalidParentCode;
    }
  } else {
    const parentData = data as ParentRegistrationData;
    if (!parentData.studentCode.trim()) {
      errors.studentCode = ERROR_MESSAGES.codeRequired;
    } else if (
      !STUDENT_CODE_PATTERN.test(parentData.studentCode.trim().toUpperCase())
    ) {
      errors.studentCode = ERROR_MESSAGES.invalidStudentCode;
    }
  }

  if (!data.acceptTerms) {
    errors.acceptTerms = ERROR_MESSAGES.termsRequired;
  }

  return errors;
};
